'use strict';

import {join} from "lodash";

export default (API) => ({
    my: {
        getMyPlacesByNameByHeadOfficesByEstablishments(name, headOfficeIds, establishmentIds) {
            const url = `v3/my/places?queryType=byName&name=${name}&headOffices=${headOfficeIds}&establishments=${establishmentIds}`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getAllMyPlaces() {
            const url = `v3/my/places?queryType=all`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getMyPlacesByIds(placeIds) {
            const url = `v3/my/places?queryType=byIds&ids=${placeIds}`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getMyResourcesByNameByHeadOfficesByEstablishments(name, headOfficeIds, establishmentIds) {
            const url = `v3/my/resources?queryType=byName&name=${name}&headOffices=${headOfficeIds}&establishments=${establishmentIds}`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getAllMyResources() {
            const url = `v3/my/resources?queryType=all`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getMyResourcesByIds(resourceIds) {
            const url = `v3/my/resources?queryType=byIds&ids=${resourceIds}`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getMyServicesByNameByHeadOfficesByEstablishments(name, headOfficeIds, establishmentIds) {
            const url = `v3/my/services?queryType=byName&name=${name}&headOffices=${headOfficeIds}&establishments=${establishmentIds}`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getAllMyServices() {
            const url = `v3/my/services?queryType=all`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getMyServicesByIds(servicesIds) {
            const url = `v3/my/services?queryType=byIds&ids=${servicesIds}`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getMyEstablishments({mode, headOfficeIds, establishmentIds, partialName, page}) {
            let params = new URLSearchParams();
            let url = `v3/my/establishments`;
            params.append('queryType', mode);
            if (headOfficeIds && headOfficeIds.length) {
                params.append('headOffices', join(headOfficeIds));
            }
            if (mode === 'byIds' && establishmentIds && establishmentIds.length) {
                params.append('ids', join(establishmentIds));
            }
            if (mode === 'byName' && partialName && partialName.trim().length > 0) {
                params.append('name', partialName);
            }
            if (page && page > 0) {
                params.append('page', page);
            }
            return API.handleError(API.http.get(url + '?' + params.toString()));
        },

        getMyPlaces({mode, headOfficeIds, establishmentIds, placeIds, partialName, page}) {
            let params = new URLSearchParams();
            let url = `v3/my/places`;
            params.append('queryType', mode);
            if (headOfficeIds && headOfficeIds.length) {
                params.append('headOffices', join(headOfficeIds));
            }
            if (establishmentIds && establishmentIds.length) {
                params.append('establishments', join(establishmentIds));
            }
            if (mode === 'byIds' && placeIds && placeIds.length) {
                params.append('ids', join(placeIds));
            }
            if (mode === 'byName' && partialName && partialName.trim().length > 0) {
                params.append('name', partialName);
            }
            if (page && page > 0) {
                params.append('page', page);
            }
            return API.handleError(API.http.get(url + '?' + params.toString()));
        },

        getMyServices({mode, headOfficeIds, establishmentIds, serviceIds, partialName, page}) {
            let params = new URLSearchParams();
            let url = `v3/my/services`;
            params.append('queryType', mode);
            if (headOfficeIds && headOfficeIds.length) {
                params.append('headOffices', join(headOfficeIds));
            }
            if (establishmentIds && establishmentIds.length) {
                params.append('establishments', join(establishmentIds));
            }
            if (mode === 'byIds' && serviceIds && serviceIds.length) {
                params.append('ids', join(serviceIds));
            }
            if (mode === 'byName' && partialName && partialName.trim().length > 0) {
                params.append('name', partialName);
            }
            if (page && page > 0) {
                params.append('page', page);
            }
            return API.handleError(API.http.get(url + '?' + params.toString()));
        },

        getMyResources({mode, headOfficeIds, establishmentIds, resourceIds, partialName, page}) {
            let params = new URLSearchParams();
            let url = `v3/my/resources`;
            params.append('queryType', mode);
            if (headOfficeIds && headOfficeIds.length) {
                params.append('headOffices', join(headOfficeIds));
            }
            if (establishmentIds && establishmentIds.length) {
                params.append('establishments', join(establishmentIds));
            }
            if (mode === 'byIds' && resourceIds && resourceIds.length) {
                params.append('ids', join(resourceIds));
            }
            if (mode === 'byName' && partialName && partialName.trim().length > 0) {
                params.append('name', partialName);
            }
            if (page !== null) {
                params.append('page', page);
            }
            return API.handleError(API.http.get(url + '?' + params.toString()));
        },

        getMyEstablishmentsByNameByHeadOffices(name, headOfficeIds) {
            const url = `v3/my/establishments?queryType=byName&name=${name}&headOffices=${headOfficeIds}`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getAllMyEstablishments() {
            const url = `v3/my/establishments?queryType=all`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getMyEstablishmentsByIds(establishmentsIds) {
            const url = `v3/my/establishments?queryType=byIds&ids=${establishmentsIds}`;
            const request = API.http.get(url);
            return API.handleError(request);
        }
    }
});
